import axios from "axios"

const baseURL = process.env.REACT_APP_BASE_URL;
export const axiosInstance = axios.create({
    baseURL,
    headers: {
        Authorization: "Bearer " + process.env.REACT_APP_API_AUTHORIZATION_TOKEN
    }
})

axiosInstance.interceptors.response.use(config => config, (error) => {
    const config = error;
    return Promise.reject(error)
})